import React, { useState } from "react";
import {
  Text,
  Modal,
  createStyles,
  Group,
  Button,
  Box,
  Select,
} from "@mantine/core";
import { MonthPickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import TaskViewReportModal from "./TaskViewReportModal";
import { useSelector } from "react-redux";
import { IconChevronDown } from "@tabler/icons-react";
import { getAllTasks } from "../../../services/task";
import moment from "moment";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },
  mymodal: {
    width: 818,
    overflow: "visible",
    "& .mantine-Modal-content": {
      height: "600px !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  reportInputFields: {
    margin: "auto",
    marginBottom: 10,
    borderBottomColor: "#FFBA4599",
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
    paddingBottom: 20,
    display: "flex",
    flexDirection: "row",
  },
  viewBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
}));

const AddTaskReport = ({ opened, onclose, title }) => {
  const { classes } = useStyles();
  const [taskViewModalOpened, setTaskViewModalOpened] = useState(false);
  const [clientDetail, setClientDetail] = useState();
  const { allPatients } = useSelector((state) => state?.patient);

  const form = useForm({
    initialValues: {
      monthValue: [],
      client: null,
    },
    validate: {
      client: (value) => (value ? null : "Client is Required"),
      monthValue: (value) =>
        value.length > 0 ? null : "Please select at least one month.",
    },
  });

  // useEffect(() => {
  //   if (clientDetail){
  //   }
  //   }, [clientDetail]);

  const handleReportClick = (value) => {
    const validationResult = form.validate();
    if (validationResult.hasErrors) {
      return;
    }
    const startOfMonth = moment(form.values.monthValue?.[0])
      .startOf("month")
      .toISOString();
    const endOfMonth = moment(form.values.monthValue?.[1])
      .endOf("month")
      .toISOString();
    getAllTasks(clientDetail?.id, startOfMonth, endOfMonth);

    setTaskViewModalOpened(true);
  };

  const handleTaskViewModalClose = () => {
    setTaskViewModalOpened(false);
  };

  const handleClose = () => {
    form.reset();
    setClientDetail(null);
    onclose();
  };

  return (
    <>
      <Modal
        centered
        size={600}
        shadow="md"
        radius={"lg"}
        zIndex={1000}
        opened={opened}
        onClose={handleClose}
        overlayProps={{ blur: 3 }}
        className={classes.mymodal}
        title={
          <Group style={{ zIndex: -1 }}>
            <img src="/assets/images/addfac.png" alt="" />
            <Text ff={"Inter"} fw={600} fz={22}>
              {title}
            </Text>
          </Group>
        }
      >
        <form onSubmit={form.onSubmit(handleReportClick)}>
          <Select
            id="add-task-client-name"
            label="Client Name"
            size="md"
            value={clientDetail?.id}
            rightSectionPointerEvents="none"
            rightSection={<IconChevronDown className={classes.iconStyle} />}
            placeholder={"Select Client Name"}
            onChange={(value) => {
              const selectedClient = allPatients?.find(
                (item) => item.id === value
              );
              form.setFieldValue("client", selectedClient);
              setClientDetail(selectedClient);
            }}
            data={
              allPatients
                ?.filter((item) => item?.active === true)
                ?.map((data) => {
                  return {
                    value: data?.id,
                    label: data?.name,
                  };
                }) || []
            }
          />
          <MonthPickerInput
            mt={10}
            size="md"
            clearable
            type="range"
            allowSingleDateInRange
            label="Select Months"
            placeholder="Select Months"
            {...form.getInputProps("monthValue")}
          />

          <Box className={classes.viewBtn}>
            <Button color="yellow" c="#000" mt={20} size="md" type="submit">
              View Report
            </Button>
          </Box>
        </form>
      </Modal>
      <TaskViewReportModal
        monthValue={form.values.monthValue}
        selectedClient={clientDetail}
        opened={taskViewModalOpened}
        onClose={handleTaskViewModalClose}
      />
    </>
  );
};

export default AddTaskReport;
